// extracted by mini-css-extract-plugin
module.exports = {"loader-icon":"Loading_loader-icon__1h_RL","rotate-animation":"Loading_rotate-animation__3Z6A8"};